import React from "react";
import { useAccount, useConnect } from "wagmi";
import styled from "@emotion/styled";

const ConnectButton = () => {
  const [{ data }, connect] = useConnect();
  const [, disconnect] = useAccount();

  if (data && data.connected) {
    return (
      <StyledButton
        key={data.connectors[0].id}
        onClick={disconnect}
        connected={data.connected}
      >
        Disconnect
      </StyledButton>
    );
  }

  return (
    <StyledButton
      disabled={!data.connectors[0].ready}
      key={data.connectors[0].id}
      onClick={() => connect(data.connectors[0])}
    >
      Connect
    </StyledButton>
  );
};

const StyledButton = styled.button`
  background: ${(p) => (p.connected ? "#ee7824" : "#89b95f")};
  color: white;
  margin: 1em 2em;
  font-size: 1.6em;
  cursor: pointer;
  text-transform: uppercase;
`;

export default ConnectButton;
